<template>
  <!--  <div class="e4s-flex-column">-->

  <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center">
    <div class="e4s-flex-row e4s-justify-flex-row-vert-center e4s-flex-grow">
      <InputDebounce
        class="e4s-square--right e4s-flex-grow"
        :class="filterSearchTerm.length ? 'e4s-input-field--highlight' : ''"
        placeholder="Search..."
        :value="filterSearchTerm"
        @input="onSearchTermChanged"
      />
      <ButtonGenericV2
        class="e4s-button--auto"
        with-input="right"
        @click="onSearchTermClear"
        :disabled="filterSearchTerm.length === 0"
        text="X"
      />
    </div>
    <div class="e4s-flex-row--end">
      <slot name="after-search" />
      <!--      <ButtonGenericV2-->
      <!--        v-if="state.howManyHeats > 1"-->
      <!--        class="e4s-button&#45;&#45;prev-next"-->
      <!--        button-type="primary"-->
      <!--        :text="state.showOverallResults ? 'Heat' : 'Overall'"-->
      <!--        @onButtonClicked="toggleOverallResults"-->
      <!--      />-->
      <InputCheckboxV2
        v-if="state.howManyHeats > 1"
        :value="state.showOverallResults"
        @input="toggleOverallResults"
        value-label="Overall"
      />
      <!--      @onButtonClicked="storeCompResults.gotoPreviousEvent('T')"-->
    </div>
  </div>

  <div class="e4s-vertical-spacer--standard"></div>

  <!--  </div>-->
  <!--  <hr class="dat-e4s-hr-only dat-e4s-hr&#45;&#45;light" />-->

  <!--BY_HEAT-->
  <div v-if="!state.showOverallResults">
    <!--Show as Links-->
    <!--    "e4s-flex-row e4s-gap&#45;&#45;standard e4s-justify-flex-row-vert-center e4s-flex-wrap e4s-full-width"-->
    <div
      v-if="showHeatsAsLinks"
      class="heat-results--nav-container"
      :class="getHeatNoAndName.length > 5 ? 'heat-results--nav-container--many-links' : ''"
    >
      <!--      {{getHeatNoAndName}}-->
      <template v-for="heatNumber in getHeatNoAndName" :key="heatNumber.heatNo">
        <PrimaryLink
          :is-disabled="heatNumber.heatNo === state.heatToShow"
          :link-text="heatNumber.heatName"
          :style="
            heatNumber.heatNo === state.heatToShow
              ? 'border-bottom: 4px solid var(--top-nav-background);'
              : ''
          "
          @click="gotoHeat(heatNumber.heatNo)"
        />
      </template>
    </div>

    <div class="e4s-vertical-spacer--standard"></div>

    <!--show heats as links-->
    <!--    heatToShow: {{ state.heatToShow }}-->
    <div v-if="showHeatsAsLinks && getHeatToShow.length > 0">
      <RaceResults
        :store-comp-results-state="storeCompResultsState"
        :individual-results="getHeatToShow"
        :entries="scheduledEvent.entries"
        :is-track="state.isTrack"
        :is-team-event="isTeamEvent"
        :heat-no="state.heatToShow!"
        :event-trial-map="eventTrialMap"
        :sorting-required="true"
      />
    </div>
    <!--/Show as Links-->

    <!--Show as Blocks-->
    <div v-if="!showHeatsAsLinks">
      <div
        v-for="(indivdualResults, heatNumber) in state.heats"
        class="e4s-flex-column e4s-gap--standard-x"
        :key="heatNumber"
      >
        <div v-if="indivdualResults.length > 0">
          <div class="e4s-vertical-spacer--standard"></div>
          <div class="e4s-flex-column e4s-lite--header-race-heat">
            <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center">
              <div v-if="state.howManyHeats > 1" class="e4s-header--400">
                <span v-text="state.isTrack ? 'Race' : 'Heat'"></span> {{ heatNumber }} of
                {{ state.howManyHeats }}
              </div>

              <div class="e4s-flex-row--end" v-if="true">
                <div
                  class="e4s-flex-column e4s-justify-flex-end e4s-header--500"
                  v-text="getTrackWind(heatNumber)"
                ></div>
              </div>
            </div>

            <div class="e4s-flex-row">
              <div
                class="e4s-flex-row e4s-justify-flex-end e4s-gap--standard e4s-header--500 e4s-justify-flex-row-vert-center"
              >
                Pos
              </div>
              <div class="e4s-flex-column e4s-justify-flex-end e4s-flex-row--end e4s-header--500">
                Result
              </div>
            </div>
          </div>
          <div class="e4s-vertical-spacer--standard"></div>
          <div class="e4s-repeatable-grid--bottom" />
          <div>
            <RaceResults
              :store-comp-results-state="storeCompResultsState"
              :individual-results="indivdualResults"
              :entries="scheduledEvent.entries"
              :is-track="state.isTrack"
              :is-team-event="isTeamEvent"
              :heat-no="heatNumber"
              :event-trial-map="eventTrialMap"
              :sorting-required="true"
            />
          </div>
        </div>
      </div>
    </div>
    <!--/Show as Blocks-->
  </div>
  <!--/BY_HEAT-->

  <!--OVER_ALL-->
  <div
    v-if="state.showOverallResults"
    class="e4s-flex-column"
    style="margin-top: var(--e4s-gap--standard)"
  >
    <div class="e4s-flex-column e4s-lite--header-race-heat">
      <div class="e4s-flex-row e4s-gap--standard e4s-justify-flex-row-vert-center">
        <div v-if="state.howManyHeats > 1" class="e4s-header--400">
          <span v-text="state.isTrack ? 'Race' : 'Heat'"></span> Overall
        </div>
      </div>

      <div class="e4s-flex-row">
        <div
          class="e4s-flex-row e4s-justify-flex-end e4s-gap--standard e4s-header--500 e4s-justify-flex-row-vert-center"
        >
          Pos
        </div>
        <div class="e4s-flex-column e4s-justify-flex-end e4s-flex-row--end e4s-header--500">
          Result
        </div>
      </div>
    </div>
    <div class="e4s-vertical-spacer--standard"></div>
    <div class="e4s-repeatable-grid--bottom" />
    <RaceResults
      :store-comp-results-state="storeCompResultsState"
      :individual-results="state.overallResults"
      :entries="scheduledEvent.entries"
      :is-track="state.isTrack"
      :is-team-event="isTeamEvent"
      heat-no="Overall"
      :event-trial-map="eventTrialMap"
      :sorting-required="false"
    />
  </div>
  <!--/OVER_ALL-->

  <!--  {{ state.heats }}-->
</template>

<script setup lang="ts">
import type {
  AthleteTrialMap,
  CompEvent,
  HeatNoString,
  IndividualResult,
  StoreCompResultsState
} from '@/components/results/store-comp-results'
import type { IndividualResultWithHeat } from '@/components/results/results-service'
import { computed, type PropType, reactive, ref, watch } from 'vue'
import RaceResults from '@/components/results/race-results/RaceResults.vue'
import * as ResultsService from '@/components/results/results-service'
import InputDebounce from '@/common/ui/fields/input-debounce.vue'
import { simpleClone } from '@/services/common-service-utils'
import type { AthleteIdString, EventGroupId } from '@/services/common'
import ButtonGenericV2 from '@/common/ui/buttons/button-generic-v2.vue'
import InputCheckboxV2 from '@/common/ui/fields/InputCheckBoxV2.vue'
import PrimaryLink from '@/common/ui/href/PrimaryLink.vue'

interface HeatResultsState {
  searchTerm: string
  howManyHeats: number
  heats: Record<HeatNoString, IndividualResult[]>
  showOverallResults: boolean
  overallResults: IndividualResultWithHeat[]
  isTrack: boolean
  heatToShow: HeatNoString | null
}

const props = defineProps({
  storeCompResultsState: {
    type: Object as PropType<StoreCompResultsState>,
    required: true
  },
  scheduledEvent: {
    type: Object as PropType<CompEvent>,
    required: true
  },
  eventTrialMap: {
    type: Object as PropType<Record<AthleteIdString, AthleteTrialMap>>,
    default: () => {
      return {}
    }
  },
  filterSearchTerm: {
    type: String,
    default: ''
  },
  showHeatsAsLinks: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits<{
  (e: 'searchTermChanged', value: string): void
  (e: 'gotoQualifyingEvent', value: EventGroupId): void
}>()

watch(
  () => props.scheduledEvent,
  (newvalue, oldValue) => {
    console.log('HeatResults scheduledEvent changed', newvalue, oldValue)
    init()
  }
)

watch(
  () => props.filterSearchTerm,
  (newVal, oldValue) => {
    if (newVal !== filterTerm.value) {
      console.log('HeatResults.filterSearchTerm changed', newVal, oldValue)
      filterTerm.value = newVal
    }
  }
)

const filterTerm = ref('')

const state = reactive<HeatResultsState>({
  searchTerm: '',
  howManyHeats: 0,
  heats: {},
  isTrack: false,
  showOverallResults: false,
  overallResults: [],
  heatToShow: null
})

init()

// function doFilter(searchTerm: string) {
//   console.log('HeatResults.doFilter')
//   state.searchTerm = searchTerm
//   init()
// }

function init() {
  let compEvent = simpleClone(props.scheduledEvent)
  state.howManyHeats = ResultsService.howManyHeats(compEvent)

  // if (state.searchTerm.length > 0) {
  //   console.log('HeatResults.init() searchTerm: ' + state.searchTerm + '...')
  //   compEvent = ResultsService.filterResults(compEvent, state.searchTerm)
  // }

  if (compEvent.results) {
    state.heats = compEvent.results

    state.heatToShow = Object.keys(state.heats)[0] as HeatNoString
  }
  state.isTrack = ResultsService.isTrackEvent(compEvent)
}

function onSearchTermClear() {
  emit('searchTermChanged', '')
}

function onSearchTermChanged(searchTerm: string) {
  console.log('HeatResults.onSearchTermChanged', searchTerm)
  emit('searchTermChanged', searchTerm)
}

const isTeamEvent = computed(() => {
  return ResultsService.isTeamEvent(props.scheduledEvent)
})

function getTrackWind(heatNo: HeatNoString) {
  const heats: Record<HeatNoString, IndividualResult[]> = state.heats

  // get heat by heatNo from state.getEntriesGroupedByHeatNo
  const heat = heats[heatNo.toString()]
  if (!heat) {
    return ''
  }
  // get first entry
  const entry = heat[0]
  if (!entry) {
    return ''
  }
  // get wind
  const wind = entry.wind
  if (!wind) {
    return ''
  }

  console.log('HeatResults.getTrackWind', wind)

  const windStr = wind.toString()
  const hasMs = windStr.toLowerCase().includes('m/s')
  return 'Wind: ' + (hasMs ? windStr : windStr + ' m/s')
}

function toggleOverallResults() {
  state.showOverallResults = !state.showOverallResults
  if (state.showOverallResults) {
    // The function now returns results with heat information included
    state.overallResults = ResultsService.getOverallResultsWithPositions(props.scheduledEvent)
  }
}

function gotoHeat(heatNo: HeatNoString) {
  state.heatToShow = heatNo
}

const getHeatToShow = computed<IndividualResult[]>(() => {
  if (!state.heatToShow) {
    return []
  }
  return state.heats[state.heatToShow]
})

// get heat no and heat name.  Loop across the heats and return array
const getHeatNoAndName = computed(() => {
  if (state.heats) {
    //  loop through the heats and return an array of heat no and heat name
    return Object.keys(state.heats).map((heatNo) => {
      const results = state.heats[heatNo]
      // get first result
      const firstResult = results[0]

      let heatName = 'Heat ' + heatNo
      try {
        if (firstResult && firstResult.rhOptions && firstResult.rhOptions.description) {
          heatName = heatNo + ': ' + firstResult.rhOptions.description
        } else {
          console.log('HeatResults.getHeatNoAndName----', firstResult)
        }

        // we might have a description from storeCompResultsState.maps.resultsHeadersOptionsByEventGroupIdAndHeatNo
        const egId = props.scheduledEvent.egId.toString() + '-' + heatNo
        if (props.storeCompResultsState.maps.resultsHeadersOptionsByEventGroupIdAndHeatNo[egId]) {
          // now do a check if the description is not null or undefined and not an empty string
          const options =
            props.storeCompResultsState.maps.resultsHeadersOptionsByEventGroupIdAndHeatNo[egId]
              .options
          if (options && options.description) {
            heatName = heatNo + ': ' + options.description
          }

          // heatName = heatNo + ': ' + props.storeCompResultsState.maps.resultsHeadersOptionsByEventGroupIdAndHeatNo[egId].options.description
        }
      } catch (e) {
        console.log('HeatResults.getHeatNoAndName', e, firstResult)
      }
      // if (firstResult.rhOptions && firstResult.rhOptions.description) {
      //   heatName = heatNo + ': ' + firstResult.rhOptions.description
      // }

      return {
        heatNo: heatNo,
        heatName: heatName
      }
    })
  }
  return []
})
</script>

<style>
.heat-results--nav-container {
  width: 100%; /* Or a fixed px value */
  display: flex;
  gap: var(--e4s-gap--large);
  flex-wrap: wrap;
}

.heat-results--nav-container-many-links {
  justify-content: flex-start;
}
</style>
